import { Intent, ISubscriptions } from "./types";

export interface ISignUpProps {
  email: string;
  firstName: string;
  subscriptions: ISubscriptions;
  phoneNumber: string;
  intent: Intent;
  offerAccepted?: boolean;
  purchasingPurpose?: any;
  income?: number;
  propertyValue?: number;
  depositSize?: number;
  lookingForAdditionalBorrowing?: boolean;
  balance?: number;
  productEndDate?: Date;
  isLowContact?: boolean;
  referrer?: string;
}

type ISignupSuccessResponse = {
  ok: true;
  applicantId: string;
}

type ISignupFailureResponse = {
  ok: false;
  error: string;
}

type ISignupResponse = ISignupSuccessResponse | ISignupFailureResponse;

interface IAuthApiResponseBody {
  userId: string,
}

export async function Signup({
  email,
  firstName,
  phoneNumber,
  intent,
  income,
  propertyValue,
  depositSize,
  lookingForAdditionalBorrowing,
  productEndDate,
  balance,
  isLowContact,
  subscriptions,
  referrer,
}: ISignUpProps): Promise<ISignupResponse> {
  const payload = {
    username: email!,
    firstName: firstName!,
    phoneNumber: phoneNumber!,
    isFF1: true,
    rsCode: null,
    referrer,
    marketingConsent: {
      subscriptionsPost: subscriptions.post,
      subscriptionsEmail: subscriptions.email,
      subscriptionsPhone: subscriptions.phone
    },
    ff1: {
      balance,
      whatAreYouLookingToDoParam: intent,
      contactPreferencesRemo: null,
      contactPreferencesPurchase: null,
      productEndDate: productEndDate ? productEndDate.toISOString() : undefined,
      lookingForAdditionalBorrowing,
      depositSize,
      income,
      propertyValue,
      isLowContact
    }
  };

  const response = await fetch(`${AUTH_API_HOST}/auth/signup-v2`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    const result = {
      ok: false as const,
      error: "An unknown error occurred. Please try again later."
    };

    const error = await response.json();
    if (error?.error?.includes("duplicate key")) {
      result.error = "This email address is already registered. Please try logging in.";
    }

    return result;
  }

  const body: IAuthApiResponseBody = await response.json();

  return {
    ok: true,
    applicantId: body.userId
  };
}

type IMagicLinkResponse = {
  ok: boolean;
  error: string | null;
}

export async function MagicLink(email: string): Promise<IMagicLinkResponse> {
  const payload = {
    email,
    isFF1: false
  };

  const response = await fetch(`${AUTH_API_HOST}/auth/magic-link/validation-email`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    return {
      ok: false,
      error: "Failed to send magic link. Please try again later."
    };
  }

  return {
    ok: true,
    error: null
  };
}
